import mod from "-!../../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fr.vue?vue&type=script&lang=js"; export default mod; export * from "-!../../../../../../../../../node_modules/babel-loader/lib/index.js!../../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./fr.vue?vue&type=script&lang=js"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-cashback/fr.vue?vue&type=script&lang=js
// module id = LsXH
// module chunks = 0